/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

// and Sidebar.js
 
import { Link } from "react-router-dom";
import Auth from "../shared/Auth";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';

class NavItem extends BaseCom {
    render() {
        return <Link to={this.props.href} className="list-group-item"><FontAwesomeIcon icon={this.props.icon} /> {this.props.label}</Link>;
    }
}

class NavGroup extends BaseCom {
    render() {
        if (!this.props.children)
            return null;
        return <div>
            <div className="nav-header text-uppercase p-1 m-1 mb-1 pb-1">{this.props.title}</div>
            <div className="list-group">{this.props.children}</div>
        </div>;
    }
}

class Menu extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
    }

    render() {
        return <div className="container-fluid">
            <h1>Menu</h1>
            {(this.state.MODEL === 'WMS' || Auth.hasRole('manager')) && <NavGroup title="Main">
                {Auth.hasRole('manager') ? <NavItem href="/dashboard" label="Dashboard" icon={fa.faGaugeSimpleHigh} /> : ''}
                {this.state.MODEL === 'WMS' && <NavItem href="/calendar" label="Calendar" icon={fa.faCalendar} />}
                {this.state.MODEL === 'WMS' && <NavItem href="/myday" label="My Day" icon={fa.faSun} />}
            </NavGroup>}
            {this.state.MODEL === 'WMS' && <NavGroup title="Patients">
                {Auth.hasRole('manager') || Auth.hasRole('account-manager') ? <NavItem href="/lead" label="Queue" icon={fa.faNetworkWired} /> : ''}
                {Auth.hasRole('account-manager') || Auth.hasRole('provider') || Auth.hasRole('nurse') ? <NavItem href="/order" label="Patients" icon={fa.faBox} /> : ''}
            </NavGroup>}
            {this.state.MODEL === 'LIS' && <>
                <NavGroup title="Lab">
                    <NavItem href="/order/list" label={this.T('subject') + 's'} icon={fa.faBox} />
                    <NavItem href="/specimen/list" label={this.T('specimen') + 's'} icon={fa.faVial} />
                    {Auth.hasRole('admin') && <NavItem href="/lab/manager" label="Lab Management" icon={fa.faVialVirus} />}
                </NavGroup>
            </>}
            {this.state.MODEL === 'MNF' && <>
                {Auth.hasRole('manager') && <NavGroup title="Manufacturing">
                    <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} />
                    <NavItem href="/inventory/instock" label="In Stock" icon={fa.faCubes} />
                    <NavItem href="/product/list" label="Products" icon={fa.faBox} />
                </NavGroup>}
                {(Auth.hasRole('distribution-recipient') || Auth.hasRole('sub-distributor')
                    || Auth.hasRole('distributor') || Auth.hasRole('billing-distributor')) && <>
                    <NavGroup title="Distribution">
                        {!Auth.hasRole('manager') && <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} />}
                        <NavItem href="/purchase-order" label="Purchase Orders" icon={fa.faBoxes} />
                    </NavGroup>
                </>}
            </>}
            {this.state.MODEL !== 'GEN' && this.state.MODEL !== 'MNF' && Auth.hasRole('billing') && <>
                <NavGroup title="Billing">
                    <NavItem href="/claim/list" label="Claims" icon={fa.faFileInvoiceDollar} />
                </NavGroup>
            </>}
            {this.state.MODEL === 'GEN' && <>
                <NavGroup title="Work">
                    {Auth.hasRole('manager') && <NavItem href="/project" label="Projects" icon={fa.faBolt} />}
                    <NavItem href="/workorder" label="Work Order" icon={fa.faBriefcase} />
                </NavGroup>
            </>}
            <NavGroup title="Resources">
                <NavItem href="/asset-library" label="Asset Library" icon={fa.faBook} />
            </NavGroup>
            {(Auth.hasRole('account-manager') || Auth.hasRole('admin')) && <NavGroup title="Management">
                {Auth.hasRole('account-manager') && <NavItem href="/account" label="Accounts" icon={fa.faHouse} />}
                {Auth.hasRole('admin') ? <NavItem href="/invoice" label="Invoices" icon={fa.faFileInvoice} /> : ''}
                {Auth.hasRole('admin') ? <NavItem href="/quote" label="Quotes" icon={fa.faDiagramPredecessor} /> : ''}
                {Auth.hasRole('admin') ? <NavItem href="/payment-transaction" label="Payment Transaction" icon={fa.faCashRegister} /> : ''}
                {Auth.hasRole('admin') ? <NavItem href="/reports" label="Reports" icon={fa.faFileExcel} /> : ''}
            </NavGroup>}
            {(Auth.hasRole('account-manager') || Auth.hasRole('admin') || Auth.hasRole('manager')) && <>
                <NavGroup title="Admin">
                    <NavItem href="/manager" label="Administration" icon={fa.faScrewdriverWrench} />
                </NavGroup>
            </>}
        </div>;
    }
}

export default withParamsAndNavigate(Menu);